import { render, staticRenderFns } from "./PayModal.vue?vue&type=template&id=0628ef06&scoped=true&"
import script from "./PayModal.vue?vue&type=script&lang=js&"
export * from "./PayModal.vue?vue&type=script&lang=js&"
import style0 from "./PayModal.vue?vue&type=style&index=0&id=0628ef06&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0628ef06",
  null
  
)

export default component.exports